module.exports = __webpack_public_path__ + "static/city-2-699fe76e37a7f2eb222f87703f91604b.mp4";